import Vue from 'vue'
import App from './App.vue'
import routes from './routes'
import store from './store'

import { UI } from '@cyradar/ui'
import { authentication } from './api'
import localization from './localization'
import { normalizeResult } from '@/utils'
import { format } from 'date-fns'

// Import global dark modal styles
import '@/assets/styles/dark-modal.scss'

Vue.use(UI)

// Add global filters
Vue.filter('dmyhs', function (value) {
  if (!value) return ''
  try {
    const date = new Date(value)
    return format(date, 'dd/MM/yyyy HH:mm:ss')
  } catch (error) {
    console.warn('Error formatting date:', error)
    return value
  }
})

const ui = new UI({
  routes,
  store,
  auth: true,
  authAPI: authentication,
  localization,
  http: {
    unauthenticated (ui, err) {
      // Handle 401 errors with custom message for force logout
      if (err && err.response && err.response.status === 401) {
        const message = err.response.data?.message || ''

        // Check if this is a force logout (token revoked)
        if (message.includes('abort Handler') || message.includes('invalid jwt')) {
          // Dispatch logout to clear authentication state
          ui.store.dispatch('LOGOUT', { confirmed: true })

          // Show notification with clear message
          ui.store.dispatch('NOTIFY', {
            from: 'authentication',
            type: 'warning',
            text: ui.localization.t('authentication.sessionExpired')
          })
        }
      }
    }
  },
  instance: {
    show: process.env.VUE_APP_INSTANCE || process.env.VUE_APP_INSTANCE_LOGO,
    name: process.env.VUE_APP_INSTANCE,
    logo: process.env.VUE_APP_INSTANCE_LOGO,
    link: process.env.VUE_APP_INSTANCE_LINK
  },
  logo: {
    light: '/logo.png',
    dark: '/logo-white.png'
  },
  mode: 'light'
})
Vue.config.productionTip = false

Vue.mixin({
  data () {
    return {
      $_oldState: null
    }
  },
  methods: {
    $_search ({ query, start, end, history, from, pure }) {
      return this.$http
        .post('/api/v1/search', {
          query_string: query,
          start_time: start instanceof Date ? start.getTime() : start,
          end_time: end instanceof Date ? end.getTime() : end,
          history: !!history,
          from: from || 0
        })
        .then(body => {
          if (!body || !body.data) {
            return
          }

          if (pure) {
            return body.data.data
          }

          return normalizeResult(body.data.data)
        })
    },
    $_stateClone (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    $_statePersist (state) {
      this.$_oldState = this.$_stateClone(state)
    },
    $_stateRestore (keys) {
      if (!this.$_oldState) {
        return []
      }

      return keys.map(key => {
        return this.$_oldState[key]
      })
    }
  }
})

new Vue({
  ui,
  router: ui.router,
  store: ui.store,
  i18n: ui.localization,
  render: h => h(App)
}).$mount('#app')
